"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var readyCallbacks = [];
document.addEventListener('DOMContentLoaded', function () {
    domReady.done = true;
    readyCallbacks.forEach(function (callback) {
        callback();
    });
});
function domReady(callback) {
    if (domReady.done) {
        callback();
        return;
    }
    readyCallbacks.push(callback);
}
exports.domReady = domReady;
domReady.done = false;
